// extracted by css-extract-rspack-plugin
export default {"SnippetButton":"G73zw","SnippetContent":"Cxyd8","SnippetIcon":"bSAtr"};